import script from "./ScriptDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./ScriptDescription.vue?vue&type=script&setup=true&lang=js"

import "./ScriptDescription.vue?vue&type=style&index=0&id=6f94eff0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f94eff0"]])

export default __exports__